// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"d2fca6b0","269":"04ab55c2","453":"43b66fb9","634":"db7a9f8f","708":"ef6a9bf5","941":"d8218e71"}[chunkId] + ".chunk.js";
};